export const siteData = {
  clinic: {
    name: "Anish Total Dental Care",
    address: "277, Opp. Power House, EVN Rd, Erode",
    phone: "04242240802",
    mapLink: "https://maps.app.goo.gl/zxaXPMkAcJp5f3MM8",
  },
  hero: {
    titleLine1: "Where prime smiles",
    titleLine2: "meets prime",
    highlight: "Dentists",
    subtitle: "Your Trusted Dental Care Partner in Erode",
    description:
      "At Anish Total Dental Care, we believe that every smile is unique and deserves the best care. With a legacy of providing exceptional dental services in our community, we are committed to helping you achieve and maintain a healthy, beautiful smile.",
    image: "https://anishdental.netlify.app/static/media/IntroImg.15eb97da6c557d53b293.png",
    badge: "More than 10K Patients treated!",
  },
  services: {
    sectionTitle1: "What Makes Us More",
    sectionHighlight: "Special",
    sectionTitle2: "Our Services",
    items: [
      {
        title: "Laser Dentistry",
        description: "Precision dental care using advanced laser technology for faster healing and maximum comfort",
        iconImg: "/icons/laser_dentistry.png",
      },
      {
        title: "Removal of Wisdom Tooth",
        description: "Expert removal of impacted or problematic wisdom teeth using modern techniques for a painless, complication-free recovery",
        iconImg: "/icons/wisdom_tooth.png",
      },
      {
        title: "Dentures and Implants",
        description: "Restore your complete smile with natural-looking artificial teeth anchored securely for lasting stability and comfort",
        iconImg: "/icons/dentures_implants.png",
      },
      {
        title: "Orthodontic Treatment",
        description: "Straighten teeth using braces or appliances to improve bite alignment, dental function, and smile aesthetics",
        iconImg: "/icons/orthodontic.png",
      },
      {
        title: "Oral Diagnosis",
        description: "Comprehensive examination of your mouth, teeth, and gums to detect cavities, gum disease, and oral health issues, including oral cancer, at an early stage",
        iconImg: "/icons/oral_diagnosis.png",
      },
      {
        title: "Crown Restoration",
        description: "Custom-made tooth covering that restores a damaged or weakened tooth to its natural appearance and full strength",
        iconImg: "/icons/crown_restoration.png",
      },
      {
        title: "Inlays and Onlays",
        description: "Durable restorations for wider cavities where conventional fillings fail, available in tooth-color or metal for lasting results",
        iconImg: "/icons/inlays_onlays.png",
      },
      {
        title: "Root Canal",
        description: "Removes infected tissue from inside your tooth to eliminate pain, save the tooth, and prevent further damage",
        iconImg: "/icons/root_canal.png",
      },
      {
        title: "Laser Bacterial Reduction",
        description: "Advanced laser technology targets harmful bacteria in gums to treat infections and promote faster healing",
        iconImg: "/icons/laser_bacterial.png",
      },
      {
        title: "Bleaching",
        description: "Professional whitening treatment that safely brightens stained or discolored teeth to restore your radiant smile",
        iconImg: "/icons/bleaching.png",
      },
      {
        title: "Pain Therapy",
        description: "Specialized pain management techniques to address chronic dental pain, TMJ issues, and post-procedure discomfort",
        iconImg: "/icons/pain_therapy.png",
      },
      {
        title: "Invisalign Provider",
        description: "Clear, removable aligners that gradually straighten your teeth without visible braces or metal wires for a discreet treatment",
        iconImg: "/icons/invisalign.png",
      },
    ],
  },
  whyChooseUs: {
    image: "https://anishdental.netlify.app/static/media/docmam.75ff3a80ef996d3b2bbc.png",
    title: "Why Choose Us?",
    items: [
      "Expert Dentists",
      "State-of-the-Art Technology",
      "Patient-Centred Approach",
      "Transparent Pricing",
      "Coordinated Care",
      "Safety First Quality Must",
    ],
    motto: "Wellness, Compassion, Quality",
    description:
      "At Anish Total Dental Care, we are more than just a dental clinic we are a part of your community. We understand the importance of trust and transparency in healthcare. That\u2019s why we take pride in building lasting relationships with our patients, based on mutual respect and a shared goal of achieving optimal dental health.",
  },
  history: {
    sectionTitle1: "Who we are?",
    sectionTitle2: "Our Glorious",
    sectionHighlight: "History",
    image: "https://anishdental.netlify.app/static/media/smily%20patient.27c27f2e3c7d298b0891.png",
    intro:
      "Since 2000, Anish Total Dental Care Centre has proudly served the Erode community with commitment and compassion. Conveniently located in the heart of the city, opposite the powerhouse on EVN Road, our clinic provides a welcoming space designed for the utmost in cleanliness, hygiene, and patient comfort.",
    stats: [
      { value: "25+", label: "Years of Service" },
      { value: "10K+", label: "Patients Treated" },
      { value: "2011", label: "Best Teacher Award" },
      { value: "100%", label: "Sterilized Environment" },
    ],
    surgeon: {
      title: "Founded by Excellence",
      text: "Anish Total Dental Care Centre was founded by Dr. Karunakaran MDS (Chief Dental Surgeon) and Dr. Kavitha Karunakaran, with a shared vision of bringing global-standard dental care to Erode. Dr. Karunakaran, a postgraduate from the prestigious Tamil Nadu Government Dental College, Chennai, brings decades of multi-disciplinary expertise. Having served as Vice Principal at a reputed dental school, he was honored with the \u201cBest Teacher Award\u201d by Tamil Nadu Dr. MGR Medical University in 2011.",
    },
    highlights: [
      {
        title: "Comprehensive Care",
        text: "From early detection of oral cancer and root canal therapy to aesthetic smile makeovers and pediatric dentistry \u2014 we cover every field of dentistry under one roof.",
      },
      {
        title: "Modern Technology",
        text: "We practice preventive, interceptive, and corrective care, integrating conventional and cortico-basal dental implants with the latest advancements in dental technology.",
      },
      {
        title: "Trusted for Decades",
        text: "For over two decades, we\u2019ve earned the trust of our patients \u2014 many of whom return with family and friends. We deliver global-standard dental treatment at an affordable cost.",
      },
    ],
  },
  doctors: [
    {
      name: "Dr. K. Karunakaran MDS",
      role: "Chief Dental Surgeon",
      specialties: ["Oral Cancer Detection", "Root Canal", "Dental Implants"],
      location: "Erode",
      image: "https://anishdental.netlify.app/static/media/Doctor01.a0bc30c330d377d3538d.png",
    },
    {
      name: "Dr. S. Dilip MDS",
      role: "Consultant Orthodontist",
      specialties: ["Orthodontic Appliances", "Invisalign"],
      location: "Prof. SRM Dental College, Chennai",
      image: "https://customer-assets.emergentagent.com/job_anish-dentistry/artifacts/609enp7h_Dr.Dilip.jpeg",
    },
    {
      name: "Dr. Kavitha BDS",
      role: "Dental Surgeon",
      specialties: [],
      location: "Erode",
      image: "https://customer-assets.emergentagent.com/job_anish-dentistry/artifacts/sluck3ww_Dr.Kavitha.jpeg",
    },
    {
      name: "Dr. Raveena BDS",
      role: "Dental Surgeon",
      specialties: [],
      location: "Erode",
      image: "https://anishdental.netlify.app/static/media/Doctor02.a27f71e52a13f7e5a1ec.png",
    },
  ],
  testimonials: [
    {
      text: "The Clinic is always spotless and hygienic, which is crucial for a dental practice. Their use of sophisticated instruments and the latest technology ensures a high standard of care. Dr. Karunagaran is incredibly experienced and skilled. His expertise and gentle approach have always put me at ease, even during complex procedures like my recent root canal. I appreciate his clear explanations and the care he takes to ensure my comfort.",
      author: "Vidya Krishnan",
      location: "Erode",
      avatar: "https://ui-avatars.com/api/?name=Vidya+Krishnan&background=E8A317&color=fff&size=128&bold=true",
    },
    {
      text: "I lately went to Anish Total Dental Care and it was an experience like no other. I found Dr. Karunakaran extremely expert and accommodating. The clinic was immaculate, and the amazing care towards hygiene was honestly worth noticing. The nursing care was also superb. They were very attentive and kind; they genuinely made me feel comfortable throughout the entire process.",
      author: "Naveenthiran",
      location: "Erode",
      avatar: "https://ui-avatars.com/api/?name=Naveenthiran&background=3B82F6&color=fff&size=128&bold=true",
    },
    {
      text: "Best dental clinic in Erode. Dr. Karunakaran is very experienced and handles patients with great care. The clinic is very clean and well maintained. All the staff members are very friendly and cooperative. I highly recommend this clinic for all dental treatments.",
      author: "Rajesh Kumar",
      location: "Erode",
      avatar: "https://ui-avatars.com/api/?name=Rajesh+Kumar&background=10B981&color=fff&size=128&bold=true",
    },
    {
      text: "Excellent dental care! The entire team is professional and caring. Got my root canal done here and the experience was painless. The clinic uses the latest technology and maintains the highest standards of hygiene. Highly recommended for anyone looking for quality dental care in Erode.",
      author: "Priya Sundaram",
      location: "Erode",
      avatar: "https://ui-avatars.com/api/?name=Priya+Sundaram&background=8B5CF6&color=fff&size=128&bold=true",
    },
  ],
  gallery: [
    "https://anishdental.netlify.app/static/media/img1.3a987451780fc9ec903b.JPG",
    "https://anishdental.netlify.app/static/media/img2.41983e69fc251e9d55dc.JPG",
    "https://anishdental.netlify.app/static/media/img3.f642f6a8be801f7294c8.JPG",
    "https://anishdental.netlify.app/static/media/img4.3c9ff3f4fa84bff98a37.JPG",
    "https://anishdental.netlify.app/static/media/img5.6def37c6de1e7029e6d3.JPG",
    "https://anishdental.netlify.app/static/media/img6.fbc8ffd2d8152cc351d8.jpg",
  ],
};
